import { createContext, useContext, useEffect, useState, useCallback } from "react";
import { api } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";

const PrefsContext = createContext(null);

// Preferencias del usuario (Prompt 19): filtro de compañía global + tours ya vistos.
// Persistidas en el servidor (GET/PATCH /api/users/me/preferencias) — no solo localStorage,
// porque entran desde varios equipos.
export function PrefsProvider({ children }) {
  const { user } = useAuth();
  const [companies, setCompanies] = useState([]);
  const [companyFilter, setCompanyFilterState] = useState("all");
  const [toursVistos, setToursVistos] = useState({});
  const [ready, setReady] = useState(false);

  useEffect(() => {
    if (!user) return;
    api.get("/companies").then(({ data }) => setCompanies(data)).catch(() => {});
    api
      .get("/users/me/preferencias")
      .then(({ data }) => {
        setCompanyFilterState(data.company_filter || "all");
        setToursVistos(data.tours_vistos || {});
      })
      .finally(() => setReady(true));
  }, [user]);

  const setCompanyFilter = useCallback((value) => {
    setCompanyFilterState(value);
    api.patch("/users/me/preferencias", { company_filter: value }).catch(() => {});
  }, []);

  const markTourSeen = useCallback((screen) => {
    setToursVistos((prev) => ({ ...prev, [screen]: true }));
    api.patch("/users/me/preferencias", { tours_vistos: { [screen]: true } }).catch(() => {});
  }, []);

  return (
    <PrefsContext.Provider
      value={{ companies, companyFilter, setCompanyFilter, toursVistos, markTourSeen, ready }}
    >
      {children}
    </PrefsContext.Provider>
  );
}

export const usePrefs = () => useContext(PrefsContext);
